import * as yup from "yup";

export const getSchema = (
  includeRoleValidation: boolean = true,
  requireAmlEntityType: boolean = false,
) =>
  yup.object().shape({
    // Entity-only fields
    entityType: yup.string().required("Entity type required"),
    amlEntityType: requireAmlEntityType
      ? yup.string().required("AML entity type required")
      : yup.string(),
    entityName: yup.string().required("Entity name required"),
    dateOfFormation: yup.string(),
    ownershipPercentage: yup.number().when("isOwner", {
      is: true,
      then: (schema) =>
        schema
          .required("Ownership percentage is required if owner is selected")
          .typeError("Ownership percentage must be a number")
          .positive("Ownership percentage must be positive"),
    }),
    taxId: yup.string().min(5, "Tax Id must be at least 5 characters"),
    registrationNumber: yup.string(),
    natureOfBusiness: yup.string(),
    principalPlaceOfBusiness: yup.string(),
    // Address fields
    streetLine1: yup.string(),
    streetLine2: yup.string(),
    city: yup.string(),
    stateOrProvince: yup.string(),
    country: yup.string().required("Country required"),
    zipCode: yup.string(),
    isOwner: yup.boolean(),
    isController: includeRoleValidation
      ? yup
          .boolean()
          .test("at-least-one-role", "At least one role must be selected", function (value) {
            const { isOwner } = this.parent;
            return isOwner === true || value === true;
          })
      : yup.boolean(),
  });

export const schema = getSchema();
